import React, { useState } from "react";
import SourceIQLogo from "../UILibrary/SourceIQLogo";
import { useNavigate } from "react-router-dom";
import displayImage from "../../assets/InvitationPage.svg";
import { Dialog, Transition } from "@headlessui/react";

const InvitationPage = () => {
  const navigate = useNavigate();
  const [isInviteSent, setInviteSent] = useState(false);

  const handleClose = () => {
    setInviteSent(false);
    navigate("/");
  };

  return (
    <div className="min-h-screen flex flex-col md:flex-row bg-white">
      <div className="w-full md:w-1/2 p-8 md:p-16 bg-white">
        <div className="flex items-center mb-8 space-x-2">
          <div className="flex flex-row justify-start items-center gap-4">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              className="cursor-pointer"
              onClick={() =>
                navigate(
                  "/buyer-profile-registration/registration-confirmation"
                )
              }
            >
              <path
                d="M15.75 19.5L8.25 12L15.75 4.5"
                stroke="#1D2739"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
            <div className="flex justify-start items-center">
              <SourceIQLogo fill="#1E1E1E" className="w-[184px] h-[24px]" />
            </div>
          </div>
        </div>
        <div className="mt-28">
          <h1 className="text-5xl font-medium mb-10 text-left">
            Invite your teammates
          </h1>
          <p className="text-[#7E7E7E] mb-10 text-base text-left">
            Add colleagues to your company profile so they can collaborate,
            manage sourcing activities, and access supplier insights alongside
            you. Inviting teammates ensures your team stays aligned and informed
            throughout the procurement process.
          </p>
          <div className="mb-6">
            <label className="block text-[12px] mb-2 text-[#1D2739] text-left">
              Admin Email Addresses
            </label>
            <div className="relative bg-[#F9F9F9] rounded h-28 p-4 pt-6">
              <span className="absolute top-2 right-4 bg-gray-100 px-3 py-1 text-xs font-medium rounded-full">
                Admin
              </span>
              <input
                type="text"
                placeholder="Separate emails with a space"
                className="w-full h-full bg-transparent outline-none text-sm text-gray-800 placeholder:text-gray-400 border-none focus:outline-none focus:ring-0"
              />
            </div>
          </div>

          <div className="mb-10">
            <label className="block text-[12px] mb-2 text-[#1D2739] text-left">
              Member Email Addresses
            </label>
            <div className="relative bg-[#F9F9F9] rounded h-28 p-4 pt-6">
              <span className="absolute top-2 right-4 bg-gray-100 px-3 py-1 text-xs font-medium rounded-full">
                Member
              </span>
              <input
                type="text"
                placeholder="Separate emails with a space"
                className="w-full h-full bg-transparent border-none outline-none focus:outline-none focus:ring-0 text-sm text-gray-800 placeholder:text-gray-400"
              />
            </div>
          </div>
        </div>
        <div className="flex space-x-4">
          <button
            onClick={() => setInviteSent(true)}
            className="bg-[#EAF524] px-6 sm:px-2 py-3 sm:py-2 text-base sm:text-sm font-medium rounded-md shadow-md transition flex flex-row justify-start items-center"
          >
            Invite and continue to website
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="21"
              viewBox="0 0 20 21"
              fill="none"
              className="ml-2"
            >
              <path
                d="M13.5192 9.63655C14.1807 10.0224 14.1807 10.9782 13.5192 11.3641L6.50387 15.4564C5.83722 15.8453 5 15.3644 5 14.5926L5 6.40803C5 5.63624 5.83721 5.15537 6.50387 5.54425L13.5192 9.63655Z"
                fill="black"
              />
            </svg>
          </button>
          <button
            onClick={() =>
              navigate("/buyer-profile-registration/registration-confirmation")
            }
            className="text-[#1D2739] text-base hover:underline"
          >
            Cancel
          </button>
        </div>
      </div>
      <div className="hidden md:flex w-full md:w-1/2 justify-center items-center p-8 bg-[linear-gradient(201deg,_#FFF_3.05%,_#08F_147.96%)]">
        <img
          src={displayImage}
          alt=""
          className="max-w-full h-auto"
          width={654}
          height={428}
        />
      </div>

      <Transition appear show={isInviteSent}>
        <Dialog
          as="div"
          className="fixed inset-0 z-1000 overflow-y-auto"
          onClose={() => setInviteSent(false)}
        >
          <div className="min-h-screen px-4 bg-black bg-opacity-40 flex items-center justify-center">
            <Transition.Child
              enter="ease-out duration-300"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <Dialog.Panel className="inline-block w-full max-w-xl pt-12 pb-12 my-20 overflow-hidden text-center align-middle transition-all transform bg-white shadow-xl rounded-md">
                <Dialog.Title
                  as="h3"
                  className="text-xl font-semibold leading-6 text-gray-900 mb-2 flex flex-row justify-center items-center"
                >
                  Invite sent!
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="33"
                    height="32"
                    viewBox="0 0 33 32"
                    fill="none"
                    className="ml-2"
                  >
                    <path
                      d="M16.5 2C20.213 2 23.774 3.475 26.3995 6.1005C29.025 8.72601 30.5 12.287 30.5 16C30.5 19.713 29.025 23.274 26.3995 25.8995C23.774 28.525 20.213 30 16.5 30C12.787 30 9.22601 28.525 6.6005 25.8995C3.975 23.274 2.5 19.713 2.5 16C2.5 12.287 3.975 8.72601 6.6005 6.1005C9.22601 3.475 12.787 2 16.5 2ZM14.756 18.762L11.646 15.65C11.5345 15.5385 11.4021 15.4501 11.2565 15.3897C11.1108 15.3294 10.9547 15.2983 10.797 15.2983C10.6393 15.2983 10.4832 15.3294 10.3375 15.3897C10.1919 15.4501 10.0595 15.5385 9.948 15.65C9.72283 15.8752 9.59633 16.1806 9.59633 16.499C9.59633 16.8174 9.72283 17.1228 9.948 17.348L13.908 21.308C14.0192 21.4201 14.1514 21.509 14.2971 21.5697C14.4429 21.6304 14.5991 21.6616 14.757 21.6616C14.9149 21.6616 15.0711 21.6304 15.2169 21.5697C15.3626 21.509 15.4948 21.4201 15.606 21.308L23.806 13.106C23.919 12.995 24.0089 12.8627 24.0705 12.7167C24.1321 12.5708 24.1641 12.4141 24.1649 12.2557C24.1656 12.0973 24.135 11.9403 24.0748 11.7938C24.0145 11.6473 23.9259 11.5142 23.8139 11.4021C23.702 11.29 23.569 11.2012 23.4225 11.1408C23.2761 11.0804 23.1191 11.0496 22.9607 11.0501C22.8023 11.0507 22.6456 11.0826 22.4996 11.144C22.3536 11.2054 22.2212 11.2951 22.11 11.408L14.756 18.762Z"
                      fill="#0088FF"
                    />
                  </svg>
                </Dialog.Title>
                <Dialog.Description className="text-base text-[#7E7E7E] mb-4 font-medium">
                  Remind your team members to check their emails.
                </Dialog.Description>

                <button
                  type="button"
                  className="cursor-pointer mx-auto w-full max-w-[432px] h-14 p-5 mt-14 rounded-[13px] text-base font-medium bg-[#eaf524] text-black"
                  onClick={handleClose}
                >
                  Close and continue to website
                </button>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </Dialog>
      </Transition>
    </div>
  );
};

export default InvitationPage;
